import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse, Institution, User } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const DASHBOARD_URL = '/ris/dashboard/v1/reports';

export interface ParamsGetDashboardExamByRadiologist {
  approved_at_from?: string;
  approved_at_to?: string;
  approver_ids?: string[];
  export?: boolean;
  institution_ids?: string[];
  limit?: number;
  modalities?: string[];
  offset?: number;
  sort_field?: '' | 'study_date';
  sort_order?: SORT_ORDER;
  study_date_from?: string;
  study_date_to?: string;
}
export interface ResponseDashboardExamByRadiologist extends DefaultResponse {
  data: {
    age: string;
    approver: User;
    approver_id: string;
    device_name: string;
    institution: Institution;
    institution_id: string;
    patient_id: string;
    patient_name: string;
    procedure_name: string;
    study_date: string;
  }[];
}
export const getDashboardExamByRadiologist = async (
  params: ParamsGetDashboardExamByRadiologist
) => {
  const response = (await api({
    url: `${DASHBOARD_URL}/exam-by-radiologist`,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseDashboardExamByRadiologist>;

  return response.data;
};

export const getExportDashboardExamByRadiologist = async (
  params: ParamsGetDashboardExamByRadiologist
) => {
  const response = (await api({
    url: `${DASHBOARD_URL}/exam-by-radiologist`,
    method: 'GET',
    params: {
      ...params,
      export: true,
    },
    responseType: 'blob',
  })) as AxiosResponse<BlobPart>;

  return response.data;
};

export interface ParamsGetDashboardPerformByRadiologist {
  approved_at_from?: string;
  approved_at_to?: string;
  approver_ids?: string[];
  export?: boolean;
  institution_ids?: string[];
  limit?: number;
  offset?: number;
  sort_field?: '' | 'total';
  sort_order?: SORT_ORDER;
  study_date_from?: string;
  study_date_to?: string;
}
export interface ResponseDashboardPerformByRadiologist extends DefaultResponse {
  data: {
    approver: User;
    approver_id: string;
    modality_statistics: unknown;
    total: number;
  }[];
}
export const getDashboardPerformByRadiologist = async (
  params: ParamsGetDashboardPerformByRadiologist
) => {
  const response = (await api({
    url: `${DASHBOARD_URL}/perform-by-radiologist`,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseDashboardPerformByRadiologist>;

  return response.data;
};

export const getExportDashboardPerformByRadiologist = async (
  params: ParamsGetDashboardPerformByRadiologist
) => {
  const response = (await api({
    url: `${DASHBOARD_URL}/perform-by-radiologist`,
    method: 'GET',
    params: {
      ...params,
      export: true,
    },
    responseType: 'blob',
  })) as AxiosResponse<BlobPart>;

  return response.data;
};
